import React from "react";
import LegalMaterial from "../../components/LegalMaterial";
import "./style.scss";
import { useTranslation } from "react-i18next";
import usePolicyText from "../../hooks/usePolicyText";
import isPayplusDomain from "../../utils/isPayplusDomain";
import getPolicyLinks from "../../utils/getPolicyLinks";

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const { gameSites } = getPolicyLinks();
  const { renderTwoLevelParagraph, renderTitle, text } = usePolicyText(null, {
    gameSites,
  });
  const isPayplus = isPayplusDomain();
  const detailsKey = isPayplus
    ? "1_details_of_the_controlling_party_payplus"
    : "1_details_of_the_controlling_party";
  const contactsKey = isPayplus ? "2_contacts_data_payplus" : "2_contacts_data";

  return (
    <LegalMaterial header={t("privacy_title")}>
      <div className="privacy-policy-page">
        <div className="privacy-policy-page__general-desc">
          {t("privacy_general")}
        </div>
        {renderTwoLevelParagraph(detailsKey)}
        {text[detailsKey]?.define}
        <ul className="text-list">
          {(text[detailsKey]?.definitions || []).map((_, i) => {
            return (
              <li className="text-list__item" key={i}>
                <p>{t(`${detailsKey}.definitions.${i}.desc`, { gameSites })}</p>
              </li>
            );
          })}
        </ul>
        {t(`${detailsKey}.tip`)}
        {renderTwoLevelParagraph(contactsKey)}
        {renderTwoLevelParagraph("3_general_info")}
        {renderTwoLevelParagraph("4_1_your_interests")}
        {renderTwoLevelParagraph("4_2_it_sec")}
        {renderTwoLevelParagraph("4_3_handle_data_third_faces")}
        {renderTwoLevelParagraph("4_4_children")}
        {renderTwoLevelParagraph("4_5_data_storage")}
        {renderTwoLevelParagraph("5_take_inf")}
        {renderTwoLevelParagraph("5_take_inf", "5_1_getting_info")}
        {t("5_take_inf.5_1_getting_info.def")}
        <ul className="text-list">
          {text["5_take_inf"]["5_1_getting_info"].definitions.map((text, i) => {
            return (
              <li className="text-list__item" key={i}>
                {t(`5_take_inf.5_1_getting_info.definitions.${i}.desc`)}
              </li>
            );
          })}
        </ul>
        {text["5_take_inf"]["5_1_getting_info"].another_data.map((txt, i) => {
          return t(`5_take_inf.5_1_getting_info.another_data.${i}.desc`);
        })}
        {renderTitle("5_2_indirect_acquisition_of_inf")}
        {renderTwoLevelParagraph(
          "5_2_indirect_acquisition_of_inf",
          "5_2_1_inf_1"
        )}
        {renderTwoLevelParagraph(
          "5_2_indirect_acquisition_of_inf",
          "5_2_2_inf_2"
        )}
        {renderTwoLevelParagraph(
          "5_2_indirect_acquisition_of_inf",
          "5_2_3_inf_3"
        )}
        {renderTwoLevelParagraph(
          "5_2_indirect_acquisition_of_inf",
          "5_2_4_inf_4"
        )}
        {renderTwoLevelParagraph(
          "5_2_indirect_acquisition_of_inf",
          "5_2_5_inf_5"
        )}
        {/* Этап 2 (ТЗ «Нью»): раздел 5.3 — реферальная программа и баллы */}
        {renderTwoLevelParagraph("5_3_referral_program")}
        {renderTwoLevelParagraph("6_using_data")}
        {renderTwoLevelParagraph("6_using_data", "6_1_purpose_of_commun")}
        {renderTwoLevelParagraph("6_using_data", "6_2_ingame_actions")}
        {renderTwoLevelParagraph("6_using_data", "6_3_quality_improve")}
        {renderTwoLevelParagraph("6_using_data", "6_4_detect_crime")}
        {renderTwoLevelParagraph("6_using_data", "6_5_services_audit")}
        {renderTwoLevelParagraph("7_data_send")}
        {renderTwoLevelParagraph("8_1_right_access")}
        {renderTwoLevelParagraph("8_2_right_change")}
        {renderTwoLevelParagraph("8_3_right_remove")}
        {renderTwoLevelParagraph("9_complains")}
        {renderTwoLevelParagraph("10_right_to_change_policy")}
      </div>
    </LegalMaterial>
  );
}
